import React from "react";
import backBtnMobile from "../../../assets/backBtnMobile.png";
import "./aboutClassplus.css";
import { Route, Routes, Link, BrowserRouter } from "react-router-dom";
import mobileCelebrityImage from "../../../assets/MB-mobile.png";

const AboutClassplus = () => {
  return (
    <div className="mb-about-container">
      <div className="mb-about-topContainer">
       <Link to={'/'}> <img src={backBtnMobile} className="backBtnMobile" /></Link>
        <div className="mb-aboutHeading">
          ABOUT <br /> CLASSPLUS
        </div>
      </div>

      <div className="mb-about-contentContainer">
        <img src={mobileCelebrityImage} className="mb-celebrityImage" />

        <div className="mb-about-content-container">
          Classplus is a Noida-based ed-tech company that has embarked on a
          mission to touch the lives of new-age content creators. We are set to
          revolutionize the content creation landscape globally by enabling
          content creators to monetize their skills.
          <br />
          <br />
          Currently valued at 600 million dollars, We are a series-D funded
          market leader in the B2B segment helping creators build their own
          digital identities and empower their audience.
          <br />
          <br />
          Want to know more about who we are and what we do?
          <br />
          Join us on the 17th, of April at Four Seasons, Worli. We’d love to
          talk to you over a cuppa tea.
          <br />
          <br />
          See you there!
        </div>
      </div>
    </div>
  );
};

export default AboutClassplus;
